import {AbstractControl, NgControl, Validators} from '@angular/forms';
import {I18nMessage} from '@app/shared/api/model/i18n';
import {ObjectUtils} from '@shared/util/general/object-utils';

export type AceValidationErrors = Record<string, I18nMessage | null> & {required?: boolean;};

export class ValidatorUtils {

  /**
   * Set errors on control, if any error in errors is null, existing error with the same key will be cleared from the control.
   * @param control
   * @param errors
   * @param markTouched
   */
  public static setErrors(control: AbstractControl, errors: AceValidationErrors, markTouched?: boolean) {
    const errorKeys = errors ? Object.keys(errors) : null;
    if (errorKeys?.length) {
      const controlErrors = { ...control.errors };
      let controlErrorsUpdated = false;
      errorKeys.forEach(errorKey => {
        const error = errors[errorKey];
        if (ObjectUtils.isEmpty(error)) {
          if (errorKey in controlErrors) {
            delete controlErrors[errorKey];
            controlErrorsUpdated = true;
          }
        } else {
          controlErrors[errorKey] = error;
          controlErrorsUpdated = true;
        }
      });
      if (controlErrorsUpdated) {
        control.setErrors(ObjectUtils.isEmpty(controlErrors) ? null : controlErrors);
        if (markTouched) {
          control.markAsTouched();
        }
      }
    }
  }

  public static normaliseErrors(errors: AceValidationErrors): AceValidationErrors {
    return !ObjectUtils.isEmpty(errors) ? errors : null;
  }

  public static displayErrors(control: AbstractControl): boolean {
    return !!control && control.invalid && (control.dirty || control.touched) && !!control.errors;
  }

  public static isRequiredControl(ngControl: NgControl): boolean {
    return !!ngControl?.control?.hasValidator(Validators.required);
  }
}
